import { render, staticRenderFns } from "./E_SizeExample.vue?vue&type=template&id=88772f60&"
import script from "./E_SizeExample.vue?vue&type=script&lang=ts&"
export * from "./E_SizeExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.9.2_1ebeed51c9db1c19ddd7ada5173f91fd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports